module.exports = __webpack_public_path__ + "static/media/error-symbol.542435ad.svg";